export const API_URL = import.meta.env.SOLO_API_URL;
